import React, {useMemo, useRef, useState} from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import CenteredModal from '~/components/CenteredModal';

const Editor = ({
                    value,
                    onChange,
                    disabled = false,
                    errors,
                    name
}) => {
    const quillRef = useRef();

    const handleInsertUrl = () => {
        if (imageUrl && quillRef.current) {
            const quill = quillRef.current.getEditor();
            const range = quill.getSelection(true);
            quill.insertEmbed(range.index, "image", imageUrl, "user");
            quill.setSelection(range.index + 1);
        }
        setImageUrl("");
        setShowModal(false);
    };

    const handleOverrideImage = () => {
        setShowModal(true);
    }

    const modules = useMemo(() => {
        if (disabled) return { toolbar: false };
        return {
            toolbar: {
                container: [
                    [{font: []}, {size: []}],
                    ["bold", "italic", "underline", "strike"],
                    [{color: []}, {background: []}],
                    [{script: "super"}, {script: "sub"}],
                    [{header: [false, 1, 2, 3, 4, 5, 6]}, "blockquote", "code-block"],
                    [{list: "ordered"}, {indent: "-1"}, {indent: "+1"}],
                    [{direction: "rtl"}, {align: []}],
                    ["link", "image", "video"],
                    ["clean"],
                ],
                handlers: {
                    image: handleOverrideImage
                },
            }
        }
    }, [disabled]);

    const formats = [
        "header", "font", "size",
        "bold", "italic", "underline", "strike",
        "color", "background",
        "script",
        "blockquote", "code-block",
        "list", "indent",
        "direction", "align",
        "link", "image", "video",
    ];

    const [showModal, setShowModal] = useState(false);
    const [imageUrl, setImageUrl] = useState("");

    return (
        <div className="editor-container">
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={onChange}
                modules={modules}
                formats={formats}
                placeholder="Enter the content here..."
                style={{ minHeight: "300px" }}
                readOnly={disabled}
            />
            {errors && errors[name] && (
                <span className="fs-9 fw-bold text-danger">{errors[name].message}</span>
            )}
            <CenteredModal show={showModal} onClose={() => setShowModal(false)} confirmText="Insert Url" onConfirm={handleInsertUrl} >
                <div className="mb-2 image-url">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control text-primary ps-2 shadow-none"
                            id="inputUrl"
                            value={imageUrl}
                            placeholder="ENTER URL IMAGE"
                            onChange={(e) => setImageUrl(e.target.value)}
                        />
                        <label htmlFor="ENTER URL IMAGE" className="ps-2 text-body-tertiary form-icon-label text-primary">
                            ENTER URL IMAGE
                        </label>
                    </div>
                </div>
            </CenteredModal>
        </div>
    );
};

export default Editor;
